import { Routes, Route, Navigate } from "react-router-dom"
import * as screens from "../auth-screens"


const AuthNavigation = () => {
    return (
        <Routes>
            <Route path="/" element={<screens.Login />}/>
            <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
    )
}

export default AuthNavigation